import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"color":"success","elevation":"4","fab":"","width":"48","height":"48"},on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require('@/assets/image/icons/add-from-list.png'),"alt":"add-from-list"}})])}
var staticRenderFns = []

export { render, staticRenderFns }